import {
    GETCHARGENAME_SUCCESS,
    GETCHARGENAME_FAILED,
    RESET_GETCHARGENAME,
    LOADING_GETCHARGENAME,
    NETWORK_ERROR_GETCHARGENAME
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetChargeName = () => {
    return { type: RESET_GETCHARGENAME };
};

const getChargeName = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCHARGENAME });
    await partnerServices
        .post("getChargeNameList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getChargeNamesuccess(res.data));
                    break;
                default:
                    dispatch(getChargeNameFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETCHARGENAME,
                payload: err
            });
        });
};
function getChargeNamesuccess(data) {
    return {
        type: GETCHARGENAME_SUCCESS,
        payload: data
    };
}
function getChargeNameFailed(data) {
    return {
        type: GETCHARGENAME_FAILED,
        payload: data
    };
}

export { resetGetChargeName, getChargeName };
